import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store(
    {
        state: {

            siteUrl:'',
            siteId: '', //站点ID
            userInfo: {
                userid: '',
                department: []
            }, //用户登陆信息
            modelSign: 'baseNewsModel',
            isSearch: false,
            lastParams: {}, //上次搜索参数
            lastUrl: '', //上次搜索地址
            checkClassId: '', //当前选中的 二三级菜单
            secondMenu: [], // 二 三级 菜单栏
            newsList: [],  //新闻列表
            filesList: [], //文件列表
            currentPage: '', //当前页码
            detail: {},
            total: 0,  //列表总数
            firstMenuList: [],  //一级菜单列表

            firstClass: '', //一级菜单 选中id
            firstClassName: '', //一级菜单 选中名称
            secondClass: '', //儿级菜单 选中id
            secondClassName: '', //儿级菜单 选中id
            thirdClass: '', //三级菜单 选中id
            thirdClassName: '', //三级菜单 选中id
            topBanner: [], //头部bannner
            middleBanner: [], //中间banner
            noticeList: [], //首页公告列表
            FLink: [], // 外链列表
            department: [], //部门
            loading: false,

            article: {},
            httpCount: 0,
            message: '',
            messageCount: 0,
            order: 'down', //文件搜索排序 默认down
            fileType: '',  //文件搜索 文件类型,默认空
            errorMsg:'',
			noticeClassId:'',//公告的classId
			isHomePage:false,
        },
        mutations: {
            changeError(state, data) {
                state.errorMsg = data
            },
            changeOrder(state, data) {
                state.order = data
            },
            changeFileType(state, data) {
                state.fileType = data
            },
            changeMessage(state, data) {
                state.messageCount++
                state.message = data
            },
            changeSearch(state, data) {
                state.isSearch = data
            },
            changeModelSign(state, data) {
                state.modelSign = data
            },
            changeLoad(state, data) {
                state.loading = data
            },
            changeDept(state, data) {
                state.department = data
            },
            changeUserInfo(state, data) {
                state.userInfo = data
            },
            changeFLink(state, data) {
                state.FLink = data
            },
            changeNotice(state, data) {
                state.noticeList = data
            },
            changeTopBanner(state, data) {
                state.topBanner = data
            },
            changeMiddleBanner(state, data) {
                state.middleBanner = data
            },
            changeFirst(state, data) {
                state.firstMenuList = data
            },
            changeFirstClass(state, data) {
                state.firstClass = data.classId
                state.firstClassName = data.className
            },
            changeSecondClass(state, data) {
                state.secondClass = data.classId
                state.secondClassName = data.className
            },
            changeThirdClass(state, data) {
                state.thirdClass = data.classId
                state.thirdClassName = data.className
            },
            changeSiteId(state, data) {
                state.siteId = data
            },
            changeSiteUrl(state, data) {
                state.siteUrl = data
            },
            
            changeNewsList(state, data) {
                state.newsList = data
            },
            changeTotal(state, data) {
                state.total = data
            },
            changeCurrent(state, data) {
                state.currentPage = data
            },
            changeDetail(state, data) {
                state.detail = data
            },
            changeSecondMenu(state, data) {
                state.secondMenu = data
            },
            changeCheckClassId(state, data) {
                state.checkClassId = data
            },
            changeLastParams(state, data,) {
                state.lastParams = data
            },
            changeLastUrl(state, data) {
                state.lastUrl = data
            },
			changeNoticeClassId(state, noticeClassId) {
                state.noticeClassId = noticeClassId
            },
			changeIsHomePage(state, isHomePage) {
				state.isHomePage = isHomePage
			}
        }
    }
)


// WEBPACK FOOTER //
// ./src/vuex/store.js